const doesClientHaveActiveChurnThreat = (churnThreats) => {
  let isChurnThreatActive = false;

  churnThreats.forEach((threat) => {
    if (threat.resolution === 1 || threat.resolution === 4) {
      isChurnThreatActive = true;
    }
  });

  return isChurnThreatActive;
};

export default doesClientHaveActiveChurnThreat;
